import React from "react";
import { formateNumberStNdRd } from "./general-function";

function RemainingPageTitle(props) {
  const data = props.dataFromParent;
  console.log("data", data.owner);

  return (
    <div>
      <h3>
        {data?.modelyear} {data?.companyid} {data?.carmodelid} {data?.variantid}
        <span> •{data.gear}</span>
        {data?.nSaleprice && (
          <>
            <span>•</span>
            <span style={{ fontWeight: "500", color: "red" }}>
              {" "}
              ₹{Intl.NumberFormat("en-IN").format(data?.nSaleprice)}
            </span>
          </>
        )}
        <span> • {formateNumberStNdRd(data.owner)} Owner</span>
      </h3>
    </div>
  );
}

export default RemainingPageTitle;
